export default "__VITE_ASSET__B_8WSJIJ__"